// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__3Nmqz","errorLogs":"EditorFooter_errorLogs__3TUOG"};